import Box from "@mui/material/Box";
import ProgressBlock from "./ProgressBlock";
import { Stack } from "@mui/material";

export default function ProgressStatus({ statusId }) {
  function getGroupFromId(id) {
    const group1 = ["sc901510999598_hilXqAij", "sc901510999598_09mq9112"];
    const group2 = ["sc901510999598_D6IX8PvW"];
    const group3 = [
      "sc901510999598_YGW3tLf7",
      "sc901510999598_hmRooZX3",
      "sc901510999598_IrjM9MQn",
      "sc901510999598_NhM6lz3V",
    ];

    if (group1.includes(id)) return 1;
    if (group2.includes(id)) return 2;
    if (group3.includes(id)) return 3;
    return null;
  }

  const group = getGroupFromId(statusId);

  return (
    <Box
      sx={{
        mt: 4,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Stack direction="row" gap={2}>
        {[1, 2, 3].map((step) => (
          <ProgressBlock key={step} checked={group >= step} />
        ))}
      </Stack>
    </Box>
  );
}
